export default {"src":"/_next/static/media/brokenGlass_24.af131e70.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};